var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 2.95312C20.0781 0.75 16.2812 1.17188 13.8906 3.60938L13 4.54688L12.0625 3.60938C9.71875 1.17188 5.875 0.75 3.29688 2.95312C0.34375 5.48438 0.203125 9.98438 2.82812 12.7031L11.9219 22.0781C12.4844 22.6875 13.4688 22.6875 14.0312 22.0781L23.125 12.7031C25.75 9.98438 25.6094 5.48438 22.6562 2.95312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.00e29113e0e5c480e11f7824a49e5362.svg";
export { ForwardRef as ReactComponent };